const Menu = [
    {
        heading: 'Menu Administrador',
        translate: 'sidebar.heading.HEADER.Admin'
    },
    {
        name: 'Escolas',
        translate: 'menu.Escolas',
        icon : 'fa fa-building',
        submenu: [{
            name: 'Escolas para Aprovação',
            path: '/inicial'
        },{
            name: 'Nova Escola',
            path: '/novaescola',
            translate: 'menu.NovaEscola'
        },
        {
            name: 'Escolas Nacionais',
            path: '/escolas'
        },
        {
            name: 'Escolas Internacionais',
            path: '/escolasinternacionais'
        },
        {
            name: 'Escolas Inativas',
            path: '/escolasinativas'
        }]
    },
    {
        name: 'Professores',
        icon: 'fa fa-graduation-cap',
        translate: 'menu.Professores',
        submenu: [{
            name: 'Professores',
            path: '/professores',
            translate: 'menu.Professores',
        },{
            name: 'Novo Professor',
            translate: 'menu.NovoProfessor',
            path: '/novoprofessor'
        }]
    },
    {
        name: 'Alunos',
        translate: 'menu.Alunos',
        icon: 'fa fa-users',
        submenu: [{
            name: 'Alunos',
            translate: 'menu.Alunos',
            path: '/totalalunos'
        }]
    },
    {
        name: 'Dados Próprios',
        translate: 'menu.DadosProprios',
        icon: 'fa fa-user',
        submenu: [{
            name: 'Meus Dados',
            translate: 'menu.MeusDados',
            path: '/meusdados'
        },{
            translate: 'menu.TrocarSenha',
            name: 'Trocar Senha',
            path: '/trocarsenha'
        }]
    },
    {
        name: 'Desafios',
        translate: 'menu.Desafios',
        icon: 'fa fa-key',
        submenu: [{
            name: 'Nova Senha',
            translate: 'menu.NovaSenha',
            path: '/novasenha'
        },{
            name: 'Senhas',
            translate: 'menu.Senhas',
            path: '/listasenhas'
        }]
    },
    {
        name: 'Recados',
        translate: 'menu.Recados',
        icon: 'fa fa-bullhorn',
        submenu: [{
            translate: 'menu.NovoRecado',
            name: 'Novo Recado',
            path: '/novorecado'
        },{
            translate: 'menu.Recados',
            name: 'Recados',
            path: '/listarecados'
        }]
    }
];

export default Menu;
